import { render, staticRenderFns } from "./EpiteluimQuizComp.vue?vue&type=template&id=7d4c7daa&scoped=true"
import script from "./EpiteluimQuizComp.vue?vue&type=script&lang=js"
export * from "./EpiteluimQuizComp.vue?vue&type=script&lang=js"
import style0 from "./EpiteluimQuizComp.vue?vue&type=style&index=0&id=7d4c7daa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d4c7daa",
  null
  
)

export default component.exports